let PlayersExclusion = {
    EXCLUSION_SET_PLAYERS: 'EXCLUSION_SET_PLAYERS',
};

export default PlayersExclusion;
